module.exports = __webpack_public_path__ + "static/img/13077B_02_20170523_fit.8853f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13077B_02_20170523_fit.png
// module id = 6z1H
// module chunks = 0